import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const CustomLoadingMessage = (props) => {
    return (
        <components.LoadingMessage {...props}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px' }}>
                <div className="spinner-border text-primary spinner-border-sm" role="status" />
                <span>Loading...</span>
            </div>
        </components.LoadingMessage>
    );
};

const ReactSelectFiled = ({ label, name, options, value, onChange, error, placeholder, noDataMessage, isLoading = false, ...props }) => {
    const [values, setValue] = useState(null);

    useEffect(() => {
        if (!value) {
            setValue(null)
        }
    }, [value]);

    const handleChange = (option) => {
        setValue(option);
        if (onChange) onChange(option ? option.value : null, option);
    };

    return (
        <div>
            {label && <label htmlFor={name}>{label}</label>}
            <Select
                {...props}
                name={name}
                placeholder={placeholder}
                value={values}
                options={options}
                onChange={handleChange}
                className='text-start'
                styles={customStyles}
                isLoading={isLoading}
                noOptionsMessage={() =>
                    noDataMessage ? (
                        `${noDataMessage}`
                    ) : (
                        "No options"
                    )
                }
                components={{
                    LoadingMessage: CustomLoadingMessage,
                }}
            />
            {error && <div className="text-danger">{error}</div>}
        </div>
    );
};

export default ReactSelectFiled;

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        boxShadow: state.isFocused ? 'none' : provided.boxShadow,
        borderColor: state.isFocused ? '#ddd' : provided.borderColor,  // Optional: change border color on focus
        '&:hover': {
            borderColor: state.isFocused ? '#ddd' : provided.borderColor,
        },
    }),
};